$(document).ready(function () {

	$(document).on('click', '.show-submenu', function(e) {
		e.preventDefault();
		let id = $(this).data('id');

		if ($('#menu-mobile-' + id).length > 0) {
			$('#mobile-menu-products').html($('#menu-mobile-' + id).html());
			$(this).parent().parent().parent().hide();
		}
	});

    $(".drop-menu-item").hover(function() {
        $(this).find(".drop-list").toggleClass("opened");
    });
    $(".drop-list .product").hover(function() {
        $(this).find(".sub-drop-menu").toggleClass("opened");
    });

    // $(".hamburger-box").click(function(){
    //     if ($(".hamburger-box").hasClass("closed"))  {
    //         $(".hamburger-box").html("<i class='fal fa-times icon'></i>");
    //         $(".hamburger-box").removeClass("closed");
    //     } else {
    //         $(".hamburger-box").html("<i class='fal fa-bars icon'></i>");
    //         $(".hamburger-box").addClass("closed");
    //     }
    // });

    $(".hamburger").click(function(){
        $(this).toggleClass("is-active");
        $(".main-menu-mobile").toggleClass("open");
    })

    // $(".hamburger-box-mobile").click(function(){
    //     $(this).toggleClass("open");
    //     $(".main-menu-mobile").toggleClass("open");
    //     $("body").toggleClass("scroll");

    //     if($(".hamburger-box-mobile").hasClass("open")) {
    //         $(".hamburger-box-mobile").html("<i class='fal fa-times icon'></i>");
    //     } else {
    //         $(".hamburger-box-mobile").html("<i class='fal fa-bars icon'></i>");
    //     }
    // });

    $(".card .btn-link").click(function(){
        $(this).toggleClass("opened");
    });


    $(".dropdown-job-modal").click(function(){
        $(".dropdown-job-modal .form-control").toggleClass("opened");
        $(".dropdown-job-modal .dropdown-job").toggleClass("is-opened");
    });

    $('.more-less-button').click(function () {
	    var $this = $(this);

	    var growDiv = document.querySelector('.hidden-content');
	    var wrapper = document.querySelector('.grow');

	    if (growDiv.Height) {
	        growDiv.style.height = 0;
	    } else {
	        growDiv.style.height = wrapper.clientHeight + "px";
	    }

	    $this.toggleClass("closed");


	    if ($this.hasClass("closed")) {
	        $this.html(" Mai mult <i class='fal fa-plus'></i>");
	        growDiv.style.height = "0";
	    } else {
	        $this.html(" Mai putin <i class='fal fa-minus'></i>");
	        return false;
	    }
	});

	// $(".dropdown-produse .prod").click(function(){
	// 	$(this).find(".drop").toggleClass("open");
	// });
	$("header .toggle-produse").click(function(){
		var id = $(this).data('id');
		$(".dropdown-produse").not("#dropdown-menu-" + id).removeClass("open");
		$("#dropdown-menu-" + id).toggleClass("open");
	});

	window.addEventListener('click', function(e){
        if (document.getElementsByClassName('dropdown-produse-container')) {
            if (document.getElementsByClassName('dropdown-produse-container')[0].contains(e.target)){
                //console.log('Clicked in box');
            } else{
				if(!$(e.target).hasClass('toggle-produse')) {
                    //console.log('Clicked outside the box');
					$(".dropdown-produse").removeClass("open");
                }
            }
        }
	});

	$(document).on('click', '.categ-li-mob', function(e) {
		$(this).find(".submenu-mobile").toggleClass("open");
	});

	$(document).on('click', '.categ-li-mob.has-submenu', function(e) {
		$(this).find("a").toggleClass("opened");
	});

    $(".portofoliu .item .text-layer").hover(function(){
        $(".portofoliu .item").removeClass("hovered");
    });

    if ( $('.swiper-banner').length > 0 )
    {
        var swiperBanner = new Swiper('.swiper-banner', {
            pagination: {
              el: '.swiper-pagination',
              type: 'fraction',
            },
            navigation: {
              nextEl: '.swiper-banner-next',
              prevEl: '.swiper-banner-prev',
            },
        });
    }
    if (  $('.swiper-categories').length > 0  ) {
        var swiperCategories = new Swiper('.swiper-categories', {
            // slidesPerView: 1,
            freemode: true,
            spaceBetween: 0,
            slidesPerView: 'auto',
            centeredSlides: true,
            // pagination: {
            //   el: '.swiper-categories .swiper-pagination',
            //   clickable: true,
            //   dynamicBullets: true,
            // },
            navigation: {
                nextEl: '.swiper-categories-next',
                prevEl: '.swiper-categories-prev',
            },
            breakpoints: {
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 0,
                  centeredSlides: false,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 0,
                  centeredSlides: false,
                },
            },
            on: {
                slideChange: function () {
                  let index_currentSlide = swiperCategories.realIndex,
                  currentSlide = swiperCategories.slides[index_currentSlide]
                  $( currentSlide ).trigger( "click" );

                },
              },
        });
    }


});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js